export const AUTH0_DOMAIN: string | undefined = process.env.REACT_APP_AUTH0_DOMAIN
export const AUTH0_CLIENT_ID: string | undefined = process.env.REACT_APP_AUTH0_CLIENT_ID
export const LOGIN_DOMAIN: string | undefined = process.env.REACT_APP_LOGIN_DOMAIN
